// src/store/thunks/countryThunks.ts
import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosResponse } from 'axios'
import { Country } from './countrySlice'
import {
    getCountriesApi,
    postCountryApi,
    putCountryApi
} from '../../api/countryApi'

// Récupération
export const fetchCountries = createAsyncThunk<Country[]>(
    'country/fetchCountries',
    async (_, thunkAPI) => {
        try {
            const response: AxiosResponse<Country[]> = await getCountriesApi()
            return response.data
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error.response?.data?.message || 'Unknown error')
        }
    }
)

// Ajout
export const addCountry = createAsyncThunk<Country, Country>(
    'country/addCountry',
    async (newCountry, thunkAPI) => {
        try {
            const response: AxiosResponse<Country> = await postCountryApi(newCountry)
            return response.data
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error.response?.data?.message || 'Failed to add country')
        }
    }
)

// Mise à jour
export const updateCountry = createAsyncThunk<Country, Country>(
    'country/updateCountry',
    async (updatedCountry, thunkAPI) => {
        try {
            const idOrCode = String(updatedCountry.id || updatedCountry._id || updatedCountry.code || '')
            const response: AxiosResponse<Country> = await putCountryApi(idOrCode, updatedCountry)
            return response.data
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error.response?.data?.message || 'Failed to update country')
        }
    }
)
